goog.provide('el8.appchart.dialog.ordermed.qtyDetail');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.validate');
goog.require('el8.template.appchart.dialog.ordermed.qtyDetail');

el8.appchart.dialog.ordermed.qtyDetail = (function() {
    var saveCb = null;
    var cancelCb = null;
    
    var that = new el8.uiwidget.FormDialog({
        title: 'Indicate # Units per Day',
        autoHeight: true,
        width: 400,
        modal: true,
        contentFn: el8.template.appchart.dialog.ordermed.qtyDetail.content
    });
    
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'qtyPerDay',
                selector: ':input[name="qtyPerDay"]',
                infoText: '# per day...',
                maxLength: 10,
                validate: {
                    required: true,
                    number: true
                }
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });
    form.addSaveButton(function(_form) {
        var qtyPerDay = form.getVal('qtyPerDay');
        if (!form.isValid()) {
            el8.uiwidget.alert('Please enter a number for Units per Day, or hit "cancel".');
            return;
        }
        that.hide();
        if (saveCb) {
            saveCb(qtyPerDay);
        }
    }, true);
    form.addDiscardButton(function() {
        that.hide();
        if (cancelCb) {
            cancelCb();
        }
    });
    that.setForm(form);
    
    var super_show = that.show;
    that.show = function(_saveCallbackFn, _cancelCallbackFn) {
        super_show.call(that);
        saveCb = _saveCallbackFn || null;
        cancelCb = _cancelCallbackFn || null;
    };
    
    return that;
    
})();
